import { getPremiumSize } from './pergolaCatalog';

export const PRIVACY_PANEL_MAX_FEET = 12;

export const getPrivacyPanelSides = (size: string) => {
  const [nominalWidth, nominalDepth] = size.split('x').map(Number);
  const item = getPremiumSize(size);
  const width = item ? item.widthM / 0.3048 : nominalWidth;
  const depth = item ? item.depthM / 0.3048 : nominalDepth;
  return [
    { id: 'front', label: 'Front', length: width },
    { id: 'back', label: 'Back', length: width },
    { id: 'left', label: 'Left', length: depth },
    { id: 'right', label: 'Right', length: depth },
  ].map(side => ({
    ...side,
    length: Math.round(side.length * 100) / 100,
    panels: Number.isFinite(side.length) && side.length > 0
      ? Math.ceil(side.length / PRIVACY_PANEL_MAX_FEET)
      : 0,
  }));
};

export const countPrivacyPanels = (size: string, selectedSides: string[]) =>
  getPrivacyPanelSides(size).reduce(
    (total, side) => total + (selectedSides.includes(side.id) ? side.panels : 0),
    0,
  );

export const isPrivacyPanelAddon = (id: string) =>
  id === 'privacy-shade' || id === 'aluminum-panels';
